import { createClient } from '@supabase/supabase-js';

// قراءة الروابط من ملف .env الخاص بك بشكل آمن
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://xyzundrsnkrygrekyzle.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'sb_publishable_LTlBQLndxz3gkga9ddH_Kg_57ce7zif';

export const isSupabaseConfigured = true;
export const supabase = createClient(supabaseUrl, supabaseAnonKey);